<template>
  <div 
    v-if="visible" 
    class="fixed inset-0 bg-gray-600/30 backdrop-blur-sm flex items-center justify-center z-[9999]"
  >
    <div class="bg-white/95 backdrop-blur-md p-8 rounded-lg shadow-xl border border-gray-200/50 max-w-md w-full mx-4">
      <div class="flex flex-col items-center text-center">
        <!-- Spinner animato -->
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
        
        <!-- Testo personalizzabile -->
        <div class="text-gray-700 w-full">
          <h3 class="text-lg font-semibold mb-2">{{ text || $t('ui.loader.default_text') }}</h3>
          <p class="text-sm text-gray-500">{{ $t('ui.loader.subtitle') }}</p>

          <LoadingBar
            v-if="total > 0"
            :processed="processed"
            :total="total"
            class="mt-4"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import LoadingBar from '@/Components/LoadingBar.vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: ''
  },
  processed: {
    type: Number,
    default: 0
  },
  total: {
    type: Number,
    default: 0
  }
})
</script>

<style scoped>
/* Animazione personalizzata per lo spinner */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
</style>
